/* eslint-disable camelcase */
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getData } from "../Services/getData";
import { enumUrl } from "../Utils/utils";
import ReportFilters from "./ReportFilters";
import ReportsTable from "./ReportsTable";
import { postData } from "../Services/postData";
import PropTypes from "prop-types";
import moment from "moment";

function Reports({ setLoading }) {
  const notifyError = (message) => toast.error(message);
  const [reports, setReports] = useState(null);
  const [streets, setStreets] = useState(null);
  const [filters, setFilters] = useState({
    startDate: moment().subtract(1, "month"),
    endDate: moment(),
    name: "",
    cnp_cif: "",
    street: "",
    number: "",
    collectionType: {
      id: "",
      label: "",
    },
    evacuationType: {
      id: "",
      label: "",
    },
  });
  const navigate = useNavigate();
  const location = useLocation();

  /**
   *
   */
  useEffect(() => {
    if (!streets) getStreets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   *
   */
  useEffect(() => {
    getFiltersFromURL();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  /**
   *
   */
  async function getStreets() {
    setLoading(true);
    await getData(enumUrl.streets)
      .then((response) => {
        if (
          (response.status === 200 || response.status === 201) &&
          response.data
        ) {
          let tableData = [];
          response.data.forEach((street, index) => {
            tableData.push({
              id: index,
              label: street.street,
            });
          });
          setStreets(tableData);
        }
      })
      .catch((err) => {
        notifyError(err.message);
        setLoading(false);
      });
  }

  /**
   *
   */
  function getFiltersFromURL() {
    if (location.search.includes("?")) {
      let queryString = decodeURI(location.search);
      queryString = queryString.split("?");
      let newFilters = Object.assign({}, filters);
      queryString.forEach((filter) => {
        if (filter !== "") {
          const value = filter.split("=");
          if (value[0] === "startDate" || value[0] === "endDate") {
            newFilters[value[0]] = moment(value[1], "YYYY-MM-DD");
          }
          // eslint-disable-next-line prefer-destructuring
          else newFilters[value[0]] = value[1];
        }
      });
      setFilters(newFilters);
      applyFilters(newFilters);
    } else {
      navigate(
        `?startDate=${filters.startDate.format(
          "YYYY-MM-DD"
        )}?endDate=${filters.endDate.format("YYYY-MM-DD")}`
      );
    }
  }

  /**
   *
   * @param {*} newFilters
   * @returns
   */
  function getURL(newFilters) {
    let url = `?startDate=${newFilters.startDate}?endDate=${newFilters.endDate}`;
    if (newFilters.name !== "") url += `?name=${newFilters.name}`;
    if (newFilters.cnp_cif !== "") url += `?cnp_cif=${newFilters.cnp_cif}`;
    if (newFilters.street !== "") url += `?street=${newFilters.street}`;
    if (newFilters.number !== "") url += `?number=${newFilters.number}`;
    if (newFilters.collectionType !== "")
      url += `?collectionType=${newFilters.collectionType}`;
    if (newFilters.evacuationType !== "")
      url += `?evacuationType=${newFilters.evacuationType}`;
    navigate(url);
  }

  /**
   *
   */
  function applyFilters(reportFilters) {
    setLoading(true);
    const body = {
      startDate: reportFilters.startDate.format("YYYY-MM-DD"),
      endDate: reportFilters.endDate.format("YYYY-MM-DD"),
      name: reportFilters.name,
      cnp_cif: reportFilters.cnp_cif,
      number: reportFilters.number,
      street:
        typeof reportFilters.street === "object"
          ? reportFilters.street.label
          : reportFilters.street,
      collectionType:
        typeof reportFilters.collectionType === "object"
          ? reportFilters.collectionType.label
          : reportFilters.collectionType,
      evacuationType:
        typeof reportFilters.evacuationType === "object"
          ? reportFilters.evacuationType.label
          : reportFilters.evacuationType,
    };
    getURL(body);
    postData(enumUrl.report, body)
      .then((response) => {
        getReportsFromResponse(response);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        notifyError(err);
      });
  }

  /**
   *
   * @param {*} index
   * @param {*} name
   * @param {*} county
   * @param {*} city
   * @param {*} address
   * @param {*} collectionType
   * @param {*} evacuationType
   * @param {*} date
   * @param {*} isValidated
   * @returns
   */
  function createData(
    index,
    name,
    CNP,
    CIF,
    county,
    city,
    address,
    collectionType,
    evacuationType,
    date,
    isValidated
  ) {
    let fullAddress = `${address.street}, nr. ${address.nr}, `;
    if (address.bl) fullAddress += `bl. ${address.bl}, `;
    if (address.sc) fullAddress += `sc. ${address.sc}, `;
    if (address.ap) fullAddress += `ap. ${address.ap}, `;
    fullAddress += `loc. ${city}, jud. ${county}`;
    let validated = isValidated ? "Validat" : "Nevalidat";
    let cnp_cif = "";
    if (CNP) cnp_cif = CNP;
    if (CIF) cnp_cif = CIF;
    return {
      index,
      name,
      cnp_cif,
      fullAddress,
      collectionType,
      evacuationType,
      date,
      validated,
    };
  }

  /**
   *
   * @param {*} response
   */
  function getReportsFromResponse(response) {
    let tableData = [];
    response.data.forEach((form, index) => {
      tableData.push(
        createData(
          index + 1,
          form.personalData.fullName,
          form.personalData.CNP,
          form.personalData.CIF,
          form.personalData.county,
          form.personalData.city,
          form.personalData.address,
          form.systemDataCollection.collectionType,
          form.systemDataTreatment.evacuationType,
          form.date,
          form.isValidated
        )
      );
    });
    setReports(tableData);
  }

  /**
   *
   */
  // async function onGetReports() {
  //   const body = {
  //     startDate: filters.startDate.format("YYYY-MM-DD"),
  //     endDate: filters.endDate.format("YYYY-MM-DD"),
  //   };
  //   setLoading(true);
  //   await postData(enumUrl.report, body)
  //     .then((response) => {
  //       if (
  //         (response.status === 200 || response.status === 201) &&
  //         response.data
  //       ) {
  //         getReportsFromResponse(response);
  //         setLoading(false);
  //       }
  //     })
  //     .catch((err) => {
  //       notifyError(err.message);
  //       setLoading(false);
  //     });
  // }

  return (
    <div style={{ marginTop: 100 }}>
      <ReportFilters
        filters={filters}
        streets={streets}
        setFilters={setFilters}
        applyFilters={applyFilters}
      />
      <ReportsTable reports={reports} />
      <ToastContainer />
    </div>
  );
}

export default Reports;
Reports.propTypes = {
  setLoading: PropTypes.func,
};
